import {
  Bus,
  MapPin,
  Car,
  Users,
  Route,
  ClipboardList,
  Settings,
} from "lucide-react";

/**
 * Transport Management hub — derived from transport routes in App.js.
 *
 * `url` is the OWNER-style path (as used in owner routes in App.js).
 * Hub pages prepend "/staff-panel" to `url` when isPortal is true.
 *
 * `permission` is the permissionKey used in the matching
 * /staff-panel/... route's <PermissionGuard>.
 *
 * `module` is the ModuleGuard moduleCode wrapping that route.
 *
 * `permission: null` means the route isn't gated (or isn't exposed in the
 * staff portal) — owner always sees it since owner routes carry no guards
 * in App.js.
 *
 * `icon` contains the Lucide source icon. HubIcon is responsible for the
 * actual Quiet Duotone visual treatment.
 */
export const hubTransportLinks = [
  {
    sectionTitle: "Transport Operations",
    sectionIcon: Bus,

    links: [
      {
        label: "Assign Transport",
        url: "/transport/assign",
        desc: "Assign vehicle & route to students",
        module: "TRANSPORT_MANAGEMENT",
        permission: "TRANSPORT_MANAGEMENT_FULL",
        icon: Route,
      },
      {
        label: "Student Assignments",
        url: "/transport/assignments",
        desc: "View & manage all assignments",
        module: "TRANSPORT_MANAGEMENT",
        permission: "TRANSPORT_MANAGEMENT_FULL",
        icon: ClipboardList,
      },
    ],
  },

  {
    sectionTitle: "Transport Configuration",
    sectionIcon: Settings,

    links: [
      {
        label: "Vehicles",
        url: "/transport/vehicles",
        desc: "Fleet, capacity & status",
        module: "TRANSPORT_MANAGEMENT",
        permission: "TRANSPORT_MANAGEMENT_VIEW",
        icon: Car,
      },
      {
        label: "Pincode Rates",
        url: "/transport/pincode-rates",
        desc: "Zone-wise transport fees",
        module: "TRANSPORT_MANAGEMENT",
        permission: "TRANSPORT_MANAGEMENT_FULL",
        icon: MapPin,
      },
    ],
  },
];

export default hubTransportLinks;